import type { GeneralState, GlobalTrackingData } from '../types';
import get from 'lodash/get';

export default function generalInformation(
  state: GeneralState,
): GlobalTrackingData {
  // AccountState.data can be either Account or Object, so we must use get :/
  const account = get(state, 'account.data', {});
  const userId = get(account, 'id', -1);
  const experiments = get(state, 'experiments.tests', [{}]);
  const isMobile = get(state, 'env.isMobile', true);

  return { experiments, userId, isMobile };
}
